export function printJson(payload: unknown) {
  if (!payload) {
    return '';
  }
  return JSON.stringify(payload, null, 2);
}
